document.addEventListener('DOMContentLoaded', function() {
  const trigger_privacyPolicies = document.querySelectorAll('.popup-trigger-privacy-policy');
  const trigger_accessibilityStatement = document.querySelector('.popup-trigger-accessibility-statement');
  const popup_privacyPolicy = document.getElementById('custom-popup-privacy-policy');
  const popup_accessibilityStatement = document.getElementById('custom-popup-accessibility-statement');
  const to_privacyPolicies = document.querySelectorAll('.to-privacy-policy')
  const closeBtns = document.querySelectorAll('.close-btn'); // Select all close buttons
  const body = document.body;

  // Open popup
  if (trigger_privacyPolicies) {
    trigger_privacyPolicies.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        popup_privacyPolicy.style.display = 'flex';
        body.classList.add('popup-active');
      });
    });
  }

  if (trigger_accessibilityStatement) {
    trigger_accessibilityStatement.addEventListener('click', (e) => {
      e.preventDefault();
      popup_accessibilityStatement.style.display = 'flex';
      body.classList.add('popup-active');
    });
  }

  // Close popup
  function closePopup() {
    popup_privacyPolicy.style.display = 'none';
    popup_accessibilityStatement.style.display = 'none';
    body.classList.remove('popup-active');
  }

  // Attach to all close buttons
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closePopup);
  });

  // Close when clicking outside
  popup_privacyPolicy.addEventListener('click', (e) => {
    if (e.target === popup_privacyPolicy) {
      closePopup();
    }
  });
  popup_accessibilityStatement.addEventListener('click', (e) => {
    if (e.target === popup_accessibilityStatement) {
      closePopup();
    }
  });

  // Close on ESC key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closePopup();
    }
  });

  to_privacyPolicies.forEach(link => {
    link.addEventListener('click', (e)=>{
      e.preventDefault();
      closePopup()
      popup_privacyPolicy.style.display = 'flex';
      body.classList.add('popup-active');
    })
  });
});